/**
 * Mouse Parallax Effect for Slideshow
 * Makes background image follow mouse movement
 */

console.log('[Mouse Parallax] Script loaded');

class MouseParallax {
  constructor(element) {
    this.container = element;
    this.background = element.querySelector('.parallax-bg');

    if (!this.background) {
      console.warn('[Mouse Parallax] No .parallax-bg element found!');
      return;
    }

    this.mouseX = window.innerWidth / 2;
    this.mouseY = window.innerHeight / 2;
    this.winW = window.innerWidth;
    this.winH = window.innerHeight;

    // Smoothing values for fluid animation
    this.currentX = this.mouseX;
    this.currentY = this.mouseY;
    this.targetX = this.mouseX;
    this.targetY = this.mouseY;

    this.init();
  }

  init() {
    // Only activate on desktop
    if (window.innerWidth < 768) {
      return;
    }

    console.log('[Mouse Parallax] Desktop mode - parallax activated');

    // Use document-level mousemove instead of container-level
    // This ensures we catch mouse movement even if container has pointer-events issues
    document.addEventListener('mousemove', (e) => {
      this.targetX = e.clientX;
      this.targetY = e.clientY;
    });

    // Window resize handler
    window.addEventListener('resize', () => {
      this.winW = window.innerWidth;
      this.winH = window.innerHeight;
    });

    // Start smooth animation loop
    this.animate();
  }

  animate() {
    // Smooth interpolation (lerp) for fluid movement
    const smoothing = 0.1; // Lower = smoother but slower (0.05-0.2 range)

    this.currentX += (this.targetX - this.currentX) * smoothing;
    this.currentY += (this.targetY - this.currentY) * smoothing;

    this.updatePosition();

    // Continue animation loop
    requestAnimationFrame(() => this.animate());
  }

  updatePosition() {
    if (window.innerWidth < 768) return;

    // Calculate tilt angles based on smoothed mouse position
    // Normalized values between -1 and 1
    const normalizedX = (this.currentX - this.winW / 2) / (this.winW / 2);
    const normalizedY = (this.currentY - this.winH / 2) / (this.winH / 2);

    // Tilt angles (reduced max to 3 degrees for a very subtle effect)
    const maxTilt = 3;
    const tiltX = normalizedY * -maxTilt; // Inverted Y for natural tilt
    const tiltY = normalizedX * maxTilt;

    // Apply 3D rotation with perspective
    // Scale at 1.05 allows sufficient margin for a 3-degree tilt
    const transform = `perspective(1000px) rotateX(${tiltX}deg) rotateY(${tiltY}deg) scale(1.05)`;
    this.background.style.transform = transform;
    this.background.style.transformStyle = 'preserve-3d';
    // Remove CSS transition since we're using requestAnimationFrame for smooth animation
  }
}

// Initialize all parallax elements when DOM is ready
function initParallax() {
  const parallaxElements = document.querySelectorAll('.mouse-parallax-container');

  if (parallaxElements.length > 0) {
    console.log('[Mouse Parallax] Found', parallaxElements.length, 'element(s), initializing...');
    parallaxElements.forEach(el => new MouseParallax(el));
  }
}

document.addEventListener('DOMContentLoaded', initParallax);

// Also try immediate initialization in case DOM is already loaded
if (document.readyState !== 'loading') {
  initParallax();
}

// Also initialize for dynamically loaded content (Shopify theme editor)
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', initParallax);
}
